module.exports = __webpack_public_path__ + "img/Slide12.26fcd0ab.jpg";